import { useQuery } from '@tanstack/react-query';
import { kanbanApi } from '../api/kanbanApi';
import type { KanbanConfig, KanbanTemplate } from '../types/kanban';
import { useUser } from '../contexts/UserContext';

export function useKanbanConfig(listId?: number | null) {
  const { currentUser } = useUser();
  return useQuery<KanbanConfig | undefined>({
    queryKey: ['kanban-config', listId, currentUser?.email],
    queryFn: () => listId ? kanbanApi.getKanbanConfig(listId, currentUser?.email || '') : Promise.resolve(undefined),
    enabled: !!listId && !!currentUser?.email,
  });
}

export function useKanbanTemplates() {
  const { currentUser } = useUser();
  return useQuery<KanbanTemplate[]>({
    queryKey: ['kanban-templates', currentUser?.email],
    queryFn: () => kanbanApi.getKanbanTemplates(currentUser?.email || ''),
    enabled: !!currentUser?.email,
  });
}
